module.exports = __webpack_public_path__ + "4945c096a70aa58affa870a0d920a140.svg";